import { useSelector, useStore } from 'react-redux';
import { useEffect } from 'react';
import { initializeThemeWatcher } from '../../utils/themeWatcher';
import useFilterSideMenu from '../hooks/useFilterSideMenu';
import './mfe-error.css';

const MfeManager = () => {
  const { ISPM_SERVICES_ENABLED } = useSelector(state => state.user?.domainInfo || {});
  const store = useStore();

  // Filter ISPM from side menu if MFE is disabled
  useFilterSideMenu('ispm', !!ISPM_SERVICES_ENABLED);
  
  // Initialize theme watcher
  useEffect(() => {
    const cleanup = initializeThemeWatcher(store);
    return cleanup; // Cleanup on unmount
  }, [store]);

  return null; // This component doesn't render anything
};

export default MfeManager;